import { useLabel } from './hooks';

export const AREA = [
  { value: 'Removal', label: '탄소제거' },
  { value: 'Reduction', label: '탄소감축' },
];

export const SUBAREA = [
  { value: 'Forestry', label: '산림' },
  { value: 'BioChar', label: '바이오차' },
  { value: 'SoilCarbon', label: '토양탄소' },
  { value: 'DAC', label: 'DAC' },
  { value: 'RenewableEnergy', label: '재생에너지' },
  { value: 'EMobility', label: 'e-mobility' },
  { value: 'Recycle', label: '재활용' },
  { value: 'ReplaceElement', label: '대체물질' },
  { value: 'EnergyConversion', label: '에너지전환' },
  { value: 'Chemical', label: '화학공정' },
  { value: 'Agriculture', label: '농업' },
  { value: 'CCS', label: 'CCS' },
  { value: 'SecondHand', label: '중고거래' },
  { value: 'ReplaceVehicle', label: '이동수단 대체' },
  { value: 'Service', label: '서비스' },
  { value: 'Etc', label: '기타' },
];

export const useTranslationArea = () => {
  const {
    AREA_TYPE,
    SUB_AREA_TYPE_REMOVAL,
    SUB_AREA_TYPE_REDUCTION,
  } = useLabel();

  const AREA = [
    { value: 'Removal', label: AREA_TYPE['REMOVAL'] },
    { value: 'Reduction', label: AREA_TYPE['REDUCTION'] },
  ];

  const SUBAREA_REMOVAL = [
    { value: 'Forestry', label: SUB_AREA_TYPE_REMOVAL['FORESTRY'] },
    { value: 'BioChar', label: SUB_AREA_TYPE_REMOVAL['BIO_CHAR'] },
    { value: 'SoilCarbon', label: SUB_AREA_TYPE_REMOVAL['SOIL_CARBON'] },
    { value: 'DAC', label: SUB_AREA_TYPE_REMOVAL['DAC'] }
  ];

  const SUBAREA_REDUCTION = [
    { value: 'RenewableEnergy', label: SUB_AREA_TYPE_REDUCTION['RENEWABLE_ENERGY'] },
    { value: 'EMobility', label: SUB_AREA_TYPE_REDUCTION['E_MOBILITY'] },
    { value: 'Recycle', label: SUB_AREA_TYPE_REDUCTION['RECYCLE'] },
    { value: 'ReplaceElement', label: SUB_AREA_TYPE_REDUCTION['REPLACE_ELEMENT'] },
    { value: 'EnergyConversion', label: SUB_AREA_TYPE_REDUCTION['ENERGY_CONVERSION'] },
    { value: 'Chemical', label: SUB_AREA_TYPE_REDUCTION['CHEMICAL'] },
    { value: 'Agriculture', label: SUB_AREA_TYPE_REDUCTION['AGRICULTURE'] },
    { value: 'CCS', label: SUB_AREA_TYPE_REDUCTION['CCS'] },
    { value: 'SecondHand', label: SUB_AREA_TYPE_REDUCTION['SECONDHAND'] },
    { value: 'ReplaceVehicle', label: SUB_AREA_TYPE_REDUCTION['REPLACE_VEHICLE'] },
    { value: 'Service', label: SUB_AREA_TYPE_REDUCTION['SERVICE'] },
    { value: 'Etc', label: SUB_AREA_TYPE_REDUCTION['ETC'] },
  ];

  const getSubAreaMenus = (area) => {
    switch (area) {
      case 'Removal':
        return SUBAREA_REMOVAL;
      case 'Reduction':
        return SUBAREA_REDUCTION;
      default:
        return [];
    }
  };

  return {
    AREA: AREA,
    getSubAreaMenus: getSubAreaMenus,
  };
};